export default "__VITE_ASSET__DZUho6NC__"